<template>
    <div class="add-product-wholesale">
        <v-layout row justify-center>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" depressed flat class="caption font-weight-regular" style="color: #757575; text-transform: none !important;"
                            :ripple="false">
                    <template v-if="wholeSale[0] && wholeSale[0].minimum && wholeSale[0].maximum && wholeSale[0].discount">
                        {{ wholeSale[0].minimum }} - {{ wholeSale[0].maximum }}, PHP {{ formatNumber(wholeSale[0].discount) }}
                    </template>
                    <template v-else>
                        Set quantity, price
                    </template>
                    <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title class="subheading">Wholesale</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark flat @click="save">Save</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-content class="pt-0">
                        <v-form  style="background-color: #fff;">
                            <div v-for="(item, index) in wholeSale">
                                <!--<v-divider></v-divider>-->
                                <div style="margin-top: 10px;">
                                    <v-layout row justify-space-between>
                                        <h5 style="font-weight: 400; font-size: 14px; color: rgba(0,0,0,.6); margin-left: 25px; margin-bottom: 5px;">Tier {{index + 1}}</h5>
                                        <v-flex class="font-weight-regular" xs1 small  style="text-align: center" v-if="index != 0" @click="removeWholeSale(index)">X</v-flex>
                                    </v-layout>
                                </div>
                                <v-list-tile>
                                    <v-list-tile-avatar>
                                        <v-icon color="gray">assessment</v-icon>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title>Minimum</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-text-field label="Subject" placeholder="Set Minimum" suffix hide-details single-line full-width type="number" v-model="wholeSale[index].minimum"></v-text-field>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-avatar>
                                        <v-icon color="gray">mdi-tilde</v-icon>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title>Maximum</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-text-field label="Subject" placeholder="Set Maximum" suffix hide-details single-line full-width type="number" v-model="wholeSale[index].maximum"></v-text-field>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-avatar>
                                        <v-icon color="gray">local_atm</v-icon>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title>Discount</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-text-field label="Subject" placeholder="Set Discount Price" suffix hide-details single-line full-width type="number" v-model="wholeSale[index].discount"></v-text-field>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </div>
                            <v-list-tile style="background-color: #FAFAFA;">
                                <v-btn block depressed small color="primary" @click="addTier"><v-icon>add</v-icon>Add New Price Tier</v-btn>
                            </v-list-tile>
                        </v-form>

                    </v-content>
                </v-card>
            </v-dialog>
        </v-layout>
        <validation-error-modal :title="'Please input a valid value.'" @hide="validationErrorModal = false" :dialog="validationErrorModal" :error-messages="validationErrorMessages"></validation-error-modal>
    </div>
</template>
<script>
    import ValidationErrorModal from "../../components/ValidationErrorModal";
    export default {
        components: {ValidationErrorModal},
        props:{
          eventName : {
              type : String,
              default : 'setWholeSale'
          },
        },
        name : 'AddProductWholeSale',
        data() {
            return {
                dialog: false,
                wholeSale : [{minimum : '', maximum : '', discount : ''}],
                validationErrorModal : false,
                validationErrorMessages : [],
            }
        },
        watch : {

        },
        methods : {
            removeWholeSale(index){
                this.wholeSale.splice(index, 1);
            },
            addTier(){
                this.wholeSale.push({minimum : '', maximum : '', discount : ''});
            },
            save(){
                let data = {};
                data.wholeSale = this.wholeSale;
                let check = false;
                this.validationErrorMessages = [];
                this.wholeSale.forEach((value, index)=>{
                    let validateOnly = false;
                    if (value.minimum < 0 || value.minimum == ''){
                        check = true;
                        validateOnly = true;
                    }
                    if (value.maximum < 0 || value.maximum == ''){
                        check = true;
                        validateOnly = true;
                    }
                    if (value.discount < 0 || value.discount == ''){
                        check = true;
                        validateOnly = true;
                    }

                    if (validateOnly) {
                        this.validationErrorMessages.push(`Tier ${index +1} Please input a valid value`);
                    }
                });
                if (check){
                    this.validationErrorModal = true;
                    return;
                }

                EventBus.$emit(this.eventName, data);
                this.dialog = false;

            },
            formatNumber(number)
            {
                number = parseFloat(number).toFixed(2) + '';
                let x = number.split('.');
                let x1 = x[0];
                let x2 = x.length > 1 ? '.' + x[1] : '';
                let rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + ',' + '$2');
                }
                return x1 + x2;
            }
        },
        mounted(){
            EventBus.$on('setProductWholeSaleData', (data)=>{
                this.wholeSale = [];
                this.wholeSale = data;
            });
        }
    }
</script>

<style lang="scss">
    .add-product-dialog {
        .content {

            .theme--light.v-input:not(.v-input--is-disabled) input,
            .theme--light.v-input:not(.v-input--is-disabled) textarea {
                text-align: right !important;
            }
        }

    }
</style>
